import styled from 'styled-components/macro';
import tw from 'tailwind.macro';

const SubContent = styled.div`
  &::first-letter {
    ${tw`capitalize`};
  }
`;

const SpecificTextMeanHeader = styled.h4`
  &::first-letter {
    ${tw`capitalize`};
  }
`;

export { SpecificTextMeanHeader, SubContent };
